import { render, staticRenderFns } from "./ServiceAgreement.vue?vue&type=template&id=76d73871&"
import script from "./ServiceAgreement.vue?vue&type=script&lang=js&"
export * from "./ServiceAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports